var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HistoryRecord"},[_c('StdLink',{attrs:{"context":"light"}},[_vm._v("\n    "+_vm._s(_vm.date)+"\n  ")]),_c('br'),_c('span',[_vm._v("\n    "+_vm._s(_vm.BY)+" "+_vm._s(_vm.record.entry_author.email)+"\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52d0ed66","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HistoryRecord/HistoryRecord.vue
// module id = null
// module chunks = 